import {KTSVG} from '../../../../../_dashboard/helpers'
import {useIntl} from 'react-intl'
import {useMailOrdersListFilters} from '../core/MailOrdersListFiltersProvider'

const MailOrdersListSearchComponent = () => {
  const intl = useIntl()
  const {
    searchInput,
    setSearchInput,
    statusFilter,
    setStatusFilter,
    createdFromFilter,
    setCreatedFromFilter,
    createdToFilter,
    setCreatedToFilter,
  } = useMailOrdersListFilters()

  return (
    <div className='bo-filters d-flex flex-wrap gap-3 align-items-center flex-grow-1'>
      <div className='position-relative d-flex align-items-center'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-2 position-absolute ms-4'
        />
        <input
          type='text'
          className='form-control form-control-solid w-200px w-lg-250px ps-12'
          placeholder={intl.formatMessage({id: 'COMMON.SEARCH'})}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>

      <select
        className='form-select form-select-solid w-auto min-w-160px'
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value=''>{intl.formatMessage({id: 'COMMON.ALL_STATUSES'})}</option>
        <option value='pending'>{intl.formatMessage({id: 'MAIL_ORDER.STATUS.PENDING'})}</option>
        <option value='partially_paid'>
          {intl.formatMessage({id: 'MAIL_ORDER.STATUS.PARTIALLY_PAID'})}
        </option>
        <option value='paid'>{intl.formatMessage({id: 'MAIL_ORDER.STATUS.PAID'})}</option>
        <option value='expired'>{intl.formatMessage({id: 'MAIL_ORDER.STATUS.EXPIRED'})}</option>
        <option value='cancelled'>{intl.formatMessage({id: 'MAIL_ORDER.STATUS.CANCELLED'})}</option>
      </select>

      <input
        type='date'
        className='form-control form-control-solid w-auto'
        title={intl.formatMessage({id: 'MAIL_ORDER.FILTERS.CREATED_FROM'})}
        value={createdFromFilter}
        onChange={(e) => setCreatedFromFilter(e.target.value)}
      />
      <input
        type='date'
        className='form-control form-control-solid w-auto'
        title={intl.formatMessage({id: 'MAIL_ORDER.FILTERS.CREATED_TO'})}
        value={createdToFilter}
        onChange={(e) => setCreatedToFilter(e.target.value)}
      />
    </div>
  )
}

export {MailOrdersListSearchComponent}
